import dayjs from 'dayjs';
import { IUserCashBack } from 'app/shared/model/user-cash-back.model';
import { ICustomer } from 'app/shared/model/customer.model';
import { CorrectionStatus } from 'app/shared/model/enumerations/correction-status.model';

export interface ICorrection {
  id?: string;
  status?: keyof typeof CorrectionStatus | null;
  createdAt?: dayjs.Dayjs | null;
  errorType?: string | null;
  assignee?: string | null;
  correctedDeal?: string | null;
  remark?: string | null;
  userCashBack?: IUserCashBack | null;
  customer?: ICustomer | null;
}

export const defaultValue: Readonly<ICorrection> = {};
